function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import PropTypes from 'prop-types';

var RenderInTop = /*#__PURE__*/function (_Component) {
  _inherits(RenderInTop, _Component);

  var _super = _createSuper(RenderInTop);

  function RenderInTop(props) {
    var _this;

    _classCallCheck(this, RenderInTop);

    _this = _super.call(this, props);
    _this.popup = null;
    _this.renderPopupName = 'top_popup_' + _this.genId();
    var isRenderNonTopDocument = props.isRenderNonTopDocument;

    try {
      _this.renderDocument = isRenderNonTopDocument ? window.document : window.top.document;
    } catch (error) {
      _this.renderDocument = window.document;
    }

    return _this;
  }

  _createClass(RenderInTop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var type = this.props.type;
      console.log('[RenderInTop][componentDidMount] type:', type + ', this.renderPopupName:', this.renderPopupName); //新建一个div标签并塞进body

      this.popup = this.renderDocument.getElementById(this.renderPopupName);

      if (!this.popup) {
        this.popup = this.renderDocument.createElement("div");
        this.popup.setAttribute("id", this.renderPopupName);
        this.renderDocument.body.appendChild(this.popup);
      }

      this._renderLayer();

      this.initLeaveOperation();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      //在组件卸载的时候，保证弹层也被卸载掉
      this._unRenderLayer();

      this.unInitLeaveOperation();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "_renderLayer",
    value: function _renderLayer() {
      //将弹层渲染到body下的div标签
      var children = this.props.children;

      if (!this.popup || !children) {
        return;
      }

      render(children, this.popup);
    }
  }, {
    key: "_unRenderLayer",
    value: function _unRenderLayer() {
      if (!this.popup) {
        return;
      }

      var type = this.props.type;
      console.log('[RenderInTop][_unRenderLayer] type:', type + ', this.renderPopupName:', this.renderPopupName);
      unmountComponentAtNode(this.popup);
      this.renderDocument.body.removeChild(this.popup);
      this.popup = null;
    }
  }, {
    key: "genId",
    value: function genId() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      }).toUpperCase();
    }
  }, {
    key: "initLeaveOperation",
    value: function initLeaveOperation() {
      if (/localhost:/.test(window.location.href)) {
        return;
      }

      window.addEventListener("beforeunload", this.handleBeforeUnload.bind(this));
      window.addEventListener("unload", this.handleUnload.bind(this));
    }
  }, {
    key: "unInitLeaveOperation",
    value: function unInitLeaveOperation() {
      if (/localhost:/.test(window.location.href)) {
        return;
      }

      window.removeEventListener("beforeunload", this.handleBeforeUnload.bind(this));
      window.removeEventListener("unload", this.handleUnload.bind(this));
    }
  }, {
    key: "handleBeforeUnload",
    value: function handleBeforeUnload() {
      var type = this.props.type;
      console.log('[RenderInTop][handleBeforeUnload] type:', type + ', this.renderPopupName:', this.renderPopupName);

      this._unRenderLayer();
    }
  }, {
    key: "handleUnload",
    value: function handleUnload() {
      var type = this.props.type;
      console.log('[RenderInTop][handleUnload] type:', type + ', this.renderPopupName:', this.renderPopupName);

      this._unRenderLayer();
    }
  }]);

  return RenderInTop;
}(Component);

_defineProperty(RenderInTop, "propTypes", {
  children: PropTypes.any,
  type: PropTypes.string
});

export default RenderInTop;